function connect(url: string) {
  let websocket = null
  if ('WebSocket' in window) {
    websocket = new WebSocket(url)
  } else {
    alert('Not support websocket')
    return null
  }
  return websocket
}

const mixins = {
  props: {
    wsUrl: String,
    default: ''
  },
  data() {
    return {
      websocket: null
    }
  },
  mounted(this: any) {
    const url = this.wsUrl || this.websocketUrl
    if (!url) return
    this.websocket = connect(url) as WebSocket
    // 连接发生错误的回调方法
    this.websocket.onerror = () => console.log('error')
    // 连接成功建立的回调方法
    this.websocket.onopen = () => {
      console.log('open')
    }
    // 连接关闭的回调方法
    this.websocket.onclose = () => {
      console.log('close')
    }
    // 接收到消息的回调方法
    this.websocket.onmessage = (event: any) => {
      this.$emit('websocket', event.data)
    }
  },
  // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
  beforeDestroy(this: any) {
    this.websocket && this.websocket.close()
  }
}

export default mixins
